import { SiteContent, SiteMain, MainContentStart, BoundedContent, useBrowserClasses, getRootClassNames } from '@vp/swan'
import { Article } from './types/article.type'
import { ArticleView } from './components/article/Article'
import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'
import { useState } from 'react'
import { ContactUs } from '../src/components/contact-us/ContactUs'
import { ReplacementArticle } from './components/replacement-article/ReplacementArticle'
import { HelpCenterUrls } from './types/helpCenterUrls.type'

interface Props {
  tenant: string
  locale: string
  article: Article
  config?: {
    hcServiceUrl: string
  }
  helpCenterUrls: HelpCenterUrls | null
}

const SS_ARTICLE_ID = '360052262111'
const PREPLACEMENT_LOCALES = ['en-us', 'de-de', 'de-at', 'de-ch']
const ALLOWED_LOCALES = ['en-us', 'en-ca']
export const App = (props: Props) => {
  const { tenant, locale, article, helpCenterUrls } = props

  const lng = locale?.toLowerCase().replace('-', '_')
  const [shouldShowSelfService, setShouldShowSelfService] = useState(PREPLACEMENT_LOCALES.includes(locale?.toLowerCase()))
  const { t } = useTranslation(tenant)
  const bodyClassName = getRootClassNames()
  const htmlClassName = useBrowserClasses()
  const handleBackBtnClick = () => {
    if (typeof window !== 'undefined') {
      window.location.href = article.articleSectionUrl
    }
  }
  return (
    <>
      <Helmet bodyAttributes={{ class: bodyClassName }} htmlAttributes={{ class: htmlClassName }} defer>
        <title>
          {article.articleTitle ? `${article.articleTitle} - ` : ''}
          {t(`${tenant}:page.seo.title`, { lng })}
        </title>
      </Helmet>
      <SiteContent>
        <SiteMain>
          <MainContentStart>
            <BoundedContent style={{ maxWidth: '1440px' }}>
              {article.articleId === SS_ARTICLE_ID && shouldShowSelfService ? (
                <ReplacementArticle
                  locale={locale}
                  tenant={tenant}
                  onShowSelfService={(shown) => setShouldShowSelfService(shown)}
                  handleBackBtnClick={handleBackBtnClick}
                  helpCenterUrl={helpCenterUrls?.url || helpCenterUrls?.path || '/customer-care/help-center/'}
                />
              ) : (
                <ArticleView article={article} locale={locale} tenant={tenant} handleBackBtnClick={handleBackBtnClick} helpCenterUrls={helpCenterUrls} />
              )}
            </BoundedContent>
            {ALLOWED_LOCALES.includes(locale?.toLowerCase()) && <ContactUs locale={locale} tenant={tenant} articleId={article.articleId} />}
          </MainContentStart>
        </SiteMain>
      </SiteContent>
    </>
  )
}
